module.exports = "/subscriptions/assets/d77cd7782a9ea36e2fc46524a45273c3.png";